import { render, staticRenderFns } from "./TaxaSetting.vue?vue&type=template&id=578de4f8"
import script from "./TaxaSetting.vue?vue&type=script&lang=js"
export * from "./TaxaSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports